export default "__VITE_ASSET__Cnhe7LiZ__"